import { render } from "./TranslatedTextComponent.vue?vue&type=template&id=0a62614f&ts=true"
import script from "./TranslatedTextComponent.vue?vue&type=script&lang=ts"
export * from "./TranslatedTextComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__